/**
 * groovi-dialog-scroll.js — preserve scroll position when a scroll-locked
 * <dialog> closes (cart drawer, search modal, quick-add).
 *
 * THE BUG (assets/dialog.js + native sticky-add-to-cart): closing a cart drawer
 * from mid-page jumps the page to the top (most visible on mobile). dialog.js
 * locks scroll on open with `body { position:fixed; top:-<scrollY>px }` and on
 * close restores `scrollTo(previousScrollY)` correctly — BUT closing a modal
 * <dialog> then makes the browser restore focus to the previously-focused
 * element (e.g. the sticky add-to-cart button) and scroll THAT into view. That
 * focus-restore scroll fires AFTER closeDialog's own scrollTo (and a frame or
 * two later), overriding it and landing at the top. Verified live on mobile:
 * scroll is briefly correct at the `dialog:close` event, then knocked to 0.
 *
 * THE FIX (override-safe — no core edit, per CLAUDE.md rule 9): capture the lock
 * offset from `body.style.top` on `dialog:open`, then on `dialog:close` re-assert
 * the scroll AND keep correcting any scroll the deferred focus-restore triggers
 * for a short window — then release so the user can scroll freely. Applies to
 * every DialogComponent dialog (cart/search/quick-add) — same root cause.
 *
 * Events: DialogOpenEvent/DialogCloseEvent ('dialog:open'/'dialog:close') are
 * dispatched on the component with bubbles:false, so we listen in the CAPTURE
 * phase on document (capture reaches document even for non-bubbling events).
 */
(function () {
  var savedY = 0;

  document.addEventListener(
    'dialog:open',
    function () {
      // While scroll-locked, dialog.js has set body.style.top = "-<scrollY>px".
      var top = document.body.style.top;
      var parsed = top ? Math.abs(parseInt(top, 10)) : NaN;
      savedY = Number.isFinite(parsed) ? parsed : window.scrollY;
    },
    true
  );

  document.addEventListener(
    'dialog:close',
    function () {
      var target = savedY;

      var correct = function () {
        // Only counter the focus-restore jump — never trap a deliberate scroll
        // that already matches (diff 0 → no-op, so this can't loop on itself).
        if (Math.abs(window.scrollY - target) > 1) {
          window.scrollTo({ top: target, behavior: 'instant' });
        }
      };

      correct();
      // The focus-restore scroll lands a frame or two later — snap it back during
      // a short window, then stop so the user is free to scroll.
      window.addEventListener('scroll', correct, true);
      setTimeout(function () {
        window.removeEventListener('scroll', correct, true);
      }, 300);
    },
    true
  );
})();
